import { render, staticRenderFns } from "./ColumnExample.vue?vue&type=template&id=eb679728&"
import script from "./ColumnExample.vue?vue&type=script&lang=js&"
export * from "./ColumnExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports